export default "__VITE_ASSET__CT73Ed2e__"